/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_F5L9YNEVy",
    "aws_user_pools_web_client_id": "pgkjur3of0o4kbqne8pvcjruv",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS"
        ]
    },
    "aws_cognito_verification_mechanisms": [],
    "predictions": {
        "convert": {
            "speechGenerator": {
                "region": "eu-west-1",
                "proxy": false,
                "defaults": {
                    "VoiceId": "Emma",
                    "LanguageCode": "en-GB"
                }
            },
            "transcription": {
                "region": "eu-west-1",
                "proxy": false,
                "defaults": {
                    "language": "en-GB"
                }
            }
        }
    }
};


export default awsmobile;
